function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.35 21.23l-4.8-4.8a10 10 0 001.91-6.84A10 10 0 10.55 11.48a10.06 10.06 0 009 9 10 10 0 006.84-1.91l4.8 4.8a1 1 0 001.41 0l.71-.71a1 1 0 00.04-1.43zM10.5 18a7.5 7.5 0 117.5-7.5 7.5 7.5 0 01-7.5 7.5zm4-8.5a1 1 0 010 2h-3v3a1 1 0 01-2 0v-3h-3a1 1 0 010-2h3v-3a1 1 0 012 0v3z"
})));